import { z } from 'zod';
import { RESET_TYPE } from 'data/enums';

export const CoachValidatorSchema = z.object({
  id: z.string(),
  resetType: z.nativeEnum(RESET_TYPE),
});

export type CoachValidator = z.infer<typeof CoachValidatorSchema>;
